import store from "@/store";
let lang = localStorage.getItem("language");
let translate = {
  pt: {
    required: "Campo obrigatório",
    phoneCounter: "Digite um número válido (DDD + Número)",
    phoneCounterEdit: "Digite um número válido (DDD + Número)",
    phoneMaxRange: "Digite um númedo válido!",
    birthdate: "Proibido menores de 18 anos!",
    passMin: "Mínimo 8 caracteres contendo letras e números",
    passRule: "Sua senha deve conter 8 caracteres contendo letras e números",
    passCaracter: "Obrigatório ter ao menos letras e números",
    max: "Você atingiu o máximo de 50 caracteres",
    max5: "Você atingiu o máximo de 5 caracteres",
    max8: "Você atingiu o máximo de 8 caracteres",
    max10: "Você atingiu o máximo de 10 caracteres",
    max12: "Você atingiu o máximo de 12 caracteres",
    max20: "Você atingiu o máximo de 20 caracteres",
    docMax: "Você atingiu o máximo de 50 caracteres",
    docMaxEdit: "O documento CPF deve conter 14 caracteres",
    nameValid: "Digite Nome e Sobrenome",
    validateCPF: "CPF Inválido",
    validEmail: "Digite um email válido.",
    usernameMax: "Digite no mínimo 5 caracteres",
    usernameAz09: "Digite um login válido",
    emailAlreadyRegistered: "E mail já cadastrado no sistema",
    loginAlreadyRegistered: "Login já cadastrado no sistema",
    selectRequired: "Campo obrigatório",
    negativeNo: "Insira um valor válido.",
    urlNo: "Insira uma url válido.",
    noSpacesAreAllowed: "Não são permitidos espaços",
    minDeposit: "O valor mínimo para depósitos é",
    maxPercentage100: "O máximo de valor para a porcentagem do prêmio é 100.",
    maxPercentageFeeValue: "A taxa vai de 0 à 99. Use números inteiros",
    minOddValue: "O valor mínimo da odd é 1.01.",
    maxOddValue: "O valor máximo da odd é 99.",
    maxValue: "Valor não pode ser maior que 100%",
    maxValueCommission: "Valor não pode ser maior que 999.99",
    maxQuantityTokens:
      "A quantidade de tokens deve ser de 1 até o máximo de 5000",
    minRounds: "As rodadas precisam ser no mínimo 1.",
    maxRounds: "As rodadas precisam ser no máximo 100.",
    atLeastTwoChars: "Nome do time muito curto.",
    minDaysToExpire: "O mínimo de dias para expirar é 1.",
    max30DaysToExpire: "O máximo para dias de expiração é 30.",
    minDepositBondMultiplier: "O multiplicador mínimo de vínculo depósito é 1.",
    maxDepositBondMultiplier: "O multiplicador máximo de vínculo depósito é 100.",
    min3Char: "Digite no mínimo 3 caracteres",
    specialCharactersAreNotAllowed: "Caracteres especiais não são permitidos",
  },
  en: {
    required: "Required field",
    phoneCounter: "Please enter a valid number (DDD + Number)",
    phoneCounterEdit: "Please enter a valid number (DDD + Number)",
    phoneMaxRange: "Please enter a valid number!",
    birthdate: "No children under 18!",
    passMin: "Minimum 8 characters containing letters and numbers",
    passRule:
      "Your password must contain 8 characters containing letters and numbers",
    passCaracter: "Must have at least letters and numbers",
    max: "You reached the maximum of 50 characters",
    max5: "You reached the maximum of 5 characters",
    max8: "You reached the maximum of 8 characters",
    max10: "You reached the maximum of 10 characters",
    max12: "You reached the maximum of 12 characters",
    max20: "You reached the maximum of 20 characters",
    docMax: "You reached the maximum of 50 characters",
    docMaxEdit: "The CPF document must contain 14 characters",
    nameValid: "Enter First and Last Name",
    validateCPF: "Invalid CPF",
    validEmail: "Please enter a valid email.",
    usernameMax: "Please enter at least 5 characters",
    usernameAz09: "Please enter a valid login",
    emailAlreadyRegistered: "Email already registered in the system",
    loginAlreadyRegistered: "Login already registered in the system",
    selectRequired: "Required field",
    negativeNo: "Please enter a valid value.",
    urlNo: "Please enter a valid URL.",
    noSpacesAreAllowed: "No spaces allowed",
    minDeposit: "The minimum value for deposit is",
    maxPercentage100: "The maximum value for the prize percentage is 100.",
    maxPercentageFeeValue: "The fee ranges from 0 to 99. Use integer numbers",
    minOddValue: "The minimum value for the odd is 1.01.",
    maxOddValue: "The maximum value for the odd is 99.",
    maxValue: "The value cannot be greater than 100%",
    maxValueCommission: "Value cannot be greater than 999.99",
    maxQuantityTokens:
      "The number of tokens must be from 1 to a maximum of 5000",
    minRounds: "Rounds must be at least 1.",
    maxRounds: "Rounds must be a maximum of 100.",
    atLeastTwoChars: "Team name is very short.",
    minDaysToExpire: "The minimum days to expire is 1.",
    max30DaysToExpire: "The maximum days to expire is 30.",
    minDepositBondMultiplier: "The minimum deposit bond multiplier is 1.",
    maxDepositBondMultiplier: "The maximum deposit bond multiplier is 100.",
    min3Char: "Enter no minimum 3 characters",
    specialCharactersAreNotAllowed: "Special characters are not allowed",
  },
  es: {
    required: "Campo obligatorio",
    phoneCounter: "Introduzca un número válido (DDD + Número)",
    phoneCounterEdit: "Introduzca un número válido (DDD + Número)",
    phoneMaxRange: "¡Ingrese un número válido!",
    birthdate: "¡No se admiten niños menores de 18 años!",
    passMin: "Mínimo 8 caracteres que contienen letras y números",
    passRule:
      "Su contraseña debe contener 8 caracteres que contengan letras y números",
    passCaracter: "Debe tener al menos letras y números",
    max: "Has alcanzado el máximo de 50 caracteres",
    max5: "Has alcanzado el máximo de 5 caracteres",
    max8: "Has alcanzado el máximo de 8 caracteres",
    max10: "Has alcanzado el máximo de 10 caracteres",
    max12: "Has alcanzado el máximo de 12 caracteres",
    max20: "Has alcanzado el máximo de 20 caracteres",
    docMax: "Has alcanzado el máximo de 50 caracteres",
    docMaxEdit: "El documento CPF debe contener 14 caracteres",
    nameValid: "Ingrese nombre y apellido",
    validateCPF: "CPF no válido",
    validEmail: "Ingrese un correo electrónico válido.",
    usernameMax: "Por favor ingrese al menos 5 caracteres",
    usernameAz09: "Introduzca un nombre de usuario válido",
    emailAlreadyRegistered: "Correo electrónico ya registrado en el sistema",
    loginAlreadyRegistered: "Inicio de sesión ya registrado en el sistema",
    selectRequired: "Campo obligatorio",
    negativeNo: "Ingrese un valor válido.",
    urlNo: "Ingrese un valor URL.",
    noSpacesAreAllowed: "No se permiten espacios",
    minDeposit: "El valor mínimo para los depósitos es",
    maxPercentage100: "El valor máximo para el porcentaje del premio es 100.",
    maxPercentageFeeValue: "El valor máximo de la tarifa es 99",
    minOddValue: "El valor mínimo para a odd es 1.01.",
    maxOddValue: "El valor maximo para a odd es 99.",
    maxQuantityTokens: "El número de fichas debe ser de 1 a un máximo de 5000",
    maxValue: "The value cannot be greater than 100%",
    maxValueCommission: "El valor no puede ser mayor que 999.99",
    minRounds: "Las rondas deben ser al menos 1.",
    maxRounds: "Las rondas deben ser un máximo de 100.",
    atLeastTwoChars: "Nombre del equipo demasiado corto.",
    minDaysToExpire: "El mínimo de días para caducar es 1.",
    max30DaysToExpire: "El valor maximo para dias de expiracion es 30.",
    minDepositBondMultiplier:
      "El multiplicador mínimo del vínculo de depósito es 1.",
    maxDepositBondMultiplier:
      "El multiplicador máximo del vínculo de depósito es 100.",
    min3Char: "Digite no mínimo 3 caracteres",
    specialCharactersAreNotAllowed: "No se admiten caracteres especiales",
  },
};

const validate = {
  required: (value) => !!value || translate[lang].required,
  requiredAutocomplete: (v) => !!(v && v.length) || translate[lang].required,
  max: (value) => (value && value.length <= 50) || translate[lang].max,
  maxValue: (value) => (value && value <= 100) || translate[lang].maxValue,
  maxValueCommission: (value) =>
    (value && value <= 999.99) || translate[lang].maxValueCommission,
  max20: (value) => (value && value.length <= 20) || translate[lang].max20,
  docMax: (value) => (value && value.length === 14) || translate[lang].docMax,
  docMaxEdit: (value) =>
    (value && value.length === 11) || translate[lang].docMaxEdit,
  nameValid: (value) => {
    return /[A-z]{2} [A-z]{2}/.test(value) || translate[lang].nameValid;
  },
  phoneCounter: (value) =>
    (value && value.length >= 15 && value && value.length <= 16) ||
    translate[lang].phoneCounter,
  phoneCounterEdit: (value) =>
    (value && value.length === 11) || translate[lang].phoneCounterEdit,
  phoneMaxRange: (value) =>
    (value && value.length > 11 && value && value.length >= 12) ||
    translate[lang].phoneMaxRange,
  birthdate: (value) => {
    const cond = !!value;
    if (cond) {
      let date = value.split("-");
      let day = date[0];
      let month = date[1];
      let year = date[2];
      let ageYear = parseInt(year) + 18;
      let setDate = new Date(ageYear, month - 1, day);
      let currdate = new Date();
      if (currdate <= setDate) {
        return translate[lang].birthdate;
      } else {
        return true;
      }
    } else {
      return translate[lang].required;
    }
  },
  passMin: (value) => (value && value.length >= 8) || translate[lang].passMin,
  passRule: (value) => (value && value.length == 8) || translate[lang].passRule,
  passCaracter: (value) => {
    return (
      (/^[A-Za-z0-9\d=!\-@._*]*$/.test(value) &&
        /[a-z]/.test(value) &&
        /\d/.test(value)) ||
      translate[lang].passCaracter
    );
  },
  validEmail: (value) => {
    if (value == "" || value == null) {
      return true;
    } else {
      return (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        ) || translate[lang].validEmail
      );
    }
  },
  usernameMax: (v) => (v && v.length >= 5) || translate[lang].usernameMax,
  usernameAz09: (v) => {
    return (
      (/^[A-Za-z0-9\d=!\-@$._*]*$/.test(v) && /[a-z]/.test(v)) ||
      translate[lang].usernameAz09
    );
  },
  username: (v) => {
    return /^[A-Za-z0-9\d=!\-@$._*]*$/.test(v) || translate[lang].username;
  },
  selectRequired: (v) => {
    if (!v || v.length < 1) {
      return translate[lang].selectRequired;
    } else {
      return true;
    }
  },
  negativeNo: (v) => v >= 0 || translate[lang].negativeNo,
  url: (v) => {
    /* eslint-disable */
    var r = new RegExp(
      /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
    );
    // var r = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/);
    /* eslint-enable */
    return r.test(v) || translate[lang].urlNo;
  },
  noSpacesAreAllowed: (v) =>
    (v || "").indexOf(" ") < 0 || translate[lang].noSpacesAreAllowed,
  max50Characters: (v) => {
    if (v && v !== "") {
      return v.length <= 50 || translate[lang].max;
    }
    return true;
  },
  max100Value: (v) => {
    if (v && v !== "") {
      return v <= 100 || translate[lang].maxValue;
    }
    return true;
  },
  max999Value: (v) => {
    if (v && v !== "") {
      return v <= 999.99 || translate[lang].maxValueCommission;
    }
    return true;
  },
  max10Characters: (v) => {
    if (!v) {
      return true;
    }
    return v.length <= 10 || translate[lang].max10;
  },
  max12Characters: (v) => {
    if (!v) return true;

    return v.length <= 12 || translate[lang].max12;
  },
  max5Characters: (v) => {
    if (!v) {
      return true;
    }

    return v.length <= 5 || translate[lang].max5;
  },
  max8Characters: (v) => {
    if (!v) {
      return true;
    }

    return v.length <= 8 || translate[lang].max8;
  },
  minDepositRule: (v) => {
    if (!v || parseFloat(v) >= parseFloat(store.state.operator.deposit_min)) {
      return true;
    }

    return `${translate[lang].minDeposit} R$ ${store.state.operator.deposit_min}.`;
  },
  max100: (v) => v <= 100 || translate[lang].maxPercentage100,
  max99FeeValue: (v) => v <= 99 || translate[lang].maxPercentageFeeValue,
  minOddValue: (value) =>
    (value && value >= 1.01) || translate[lang].minOddValue,
  minFixedOddValue: (value) => {
    if (value) {
      value = value.replace(",", ".");
    }
    return (value && value >= 1.01) || !value || translate[lang].minOddValue;
  },
  maxFixedOddValue: (value) => {
    if (value) {
      value = value.replace(",", ".");
    }
    return (value && value <= 99) || !value || translate[lang].maxOddValue;
  },
  maxOddValue: (value) => (value && value <= 99) || translate[lang].maxOddValue,
  maxQuantityTokens: (value) =>
    (value && value <= 5000 && value > 0) || translate[lang].maxQuantityTokens,
  minRounds: (value) => (value && value >= 1) || translate[lang].minRounds,
  maxRounds: (value) => (value && value <= 100) || translate[lang].maxRounds,
  atLeastTwoChars: (value) =>
    (value && value.length >= 2) || translate[lang].atLeastTwoChars,
  minDaysToExpire: (v) => v > 0 || translate[lang].minDaysToExpire,
  max30DaysToExpire: (v) => v <= 30 || translate[lang].max30DaysToExpire,
  notEmpty: (v) => /(.|\s)*\S(.|\s)*/.test(v) || translate[lang].required,

  minDepositBondMultiplier: (v) =>
    v >= 1 || translate[lang].minDepositBondMultiplier,
  maxDepositBondMultiplier: (v) =>
    v <= 100 || translate[lang].maxDepositBondMultiplier,
  min3Characters: (v) => {
    if (!v) return true;

    return v.length >= 3 || translate[lang].min3Char;
  },

  noSpecialCharactersAllowed: (v) => !/[^\w\s]/.test(v) || translate[lang].specialCharactersAreNotAllowed

};
export { validate };
